import React, { useState } from "react";
import BaseButton from "../../../components/ui/BaseButton";
import BaseWrapper from "../../../components/ui/BaseWrapper";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { ROLES } from "../../../utils/variables";
import { resetWorkOrderForm } from "../../../store/workOrder/workOrderSlice";
import { useDispatch } from "react-redux";
import { useCurrentUser } from "../../../hooks/useCurrentUser";
import CompleteProfileModal from "../../WorkJobDetails/CompleteProfileModal";
import { ModuleType, WorkOrderStatusType } from "../../../utils/enum";
const WorkOrderListingHeader = ({
  selectedWorkOrderIds,
  status,
  setIsGenerateInvoiceModalOpen,
  onGenerateInvoiceClick,
  selectedEngineer,
  currency,
}) => {
  const dispatch = useDispatch();
  const naviagte = useNavigate();
  const { authRole, getPermissionForModule } = useAuth();
  const { hasWriteAccess } = getPermissionForModule(ModuleType.WORK_ORDERS);
  const { hasWriteAccess: hasEngineerInvoiceWriteAccess } = getPermissionForModule(
    ModuleType.ENGINEER_INVOICE,
  );
  const { userData } = useCurrentUser();
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);

  const handleNewWorkOrder = () => {
    if (!isProfileCompleted) {
      dispatch(resetWorkOrderForm());
      naviagte("/workOrder/create/summary");
    }
  };

  return (
    <div className="border-b border-zinc-300 bg-white ">
      <BaseWrapper>
        <div className="grid grid-cols-7 gap-y-3 py-[7px] items-center">
          <div className="md:col-span-2 col-span-7">
            <h3 className="font-light md:text-left text-center">Work Orders</h3>
          </div>

          {authRole !== ROLES.FREELANCE && (
            <div className="md:col-span-5 col-span-7 gap-x-4 flex  justify-end">
              {selectedWorkOrderIds?.length > 0 &&
                status?.includes(WorkOrderStatusType.APPROVED) &&
                selectedEngineer?.providerId &&
                currency &&
                hasEngineerInvoiceWriteAccess && (
                  <BaseButton
                    color="primary"
                    className="py-[4px] px-[24px]"
                    onClick={() =>
                      onGenerateInvoiceClick
                        ? onGenerateInvoiceClick()
                        : setIsGenerateInvoiceModalOpen(true)
                    }
                  >
                    Generate Invoice
                  </BaseButton>

                )}
              {hasWriteAccess && (
                <BaseButton
                  className="md:w-auto w-full"
                  // fullWidth={true}
                  variant="contained"
                  color="primary"
                  style={{
                    paddingTop: "6px",
                    paddingBottom: "6px",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                  }}
                  onClick={() => {
                    if (userData?.status !== "APPROVED") {
                      setIsProfileCompleted(true);
                      return;
                    }
                    handleNewWorkOrder();
                  }}
                >
                  Create New Work Order
                </BaseButton>
              )}
            </div>
          )}
        </div>
      </BaseWrapper>
      {isProfileCompleted && (
        <CompleteProfileModal
          isProfileCompleted={isProfileCompleted}
          setIsProfileCompleted={setIsProfileCompleted}
          status={userData?.status}
          authRole={authRole}
        />
      )}
    </div>
  );
};

export default WorkOrderListingHeader;
